export const SaleIcon = ({
  width = 16,
  height = 16,
  className,
  title = "Sale",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="currentColor"
      strokeWidth="0"
      stroke="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4624 8.99447L8.32447 16.1324C7.98017 16.4767 7.51337 16.6699 7.02651 16.6699C6.5398 16.6699 6.07307 16.4767 5.72878 16.1324L0.537638 10.9412C0.193349 10.5971 7.77878e-05 10.1302 7.7809e-05 9.64349C7.78303e-05 9.15663 0.193349 8.68974 0.537638 8.34561L7.67561 1.20764C8.01974 0.863345 8.48663 0.669922 8.97333 0.669922L13.2469 0.669922C13.977 0.669922 14.6772 0.959979 15.1936 1.47634C15.7099 1.9927 16 2.69297 16 3.42301L16 7.69659C16 8.18345 15.8067 8.65034 15.4624 8.99447ZM11.4115 3.88199C11.4115 4.24701 11.5566 4.59715 11.8148 4.8554C12.0729 5.1135 12.4231 5.25853 12.7881 5.25853C13.1533 5.25853 13.5032 5.1135 13.7615 4.8554C14.0196 4.59716 14.1646 4.24701 14.1646 3.88199C14.1646 3.51697 14.0196 3.16683 13.7615 2.90858C13.5034 2.65047 13.1533 2.50544 12.7881 2.50544C12.4231 2.50544 12.0729 2.65047 11.8148 2.90858C11.5566 3.16681 11.4115 3.51697 11.4115 3.88199ZM5.81666 9.12412C5.76732 9.60004 5.85908 10.1133 6.23403 10.4918C6.57253 10.8335 7.09016 10.9144 7.42136 10.5863C7.80681 10.2045 7.59586 9.68963 7.37222 9.14381C7.26949 8.8931 7.16409 8.63587 7.11259 8.38199C7.02569 7.94729 7.07493 7.49229 7.4587 7.11213C7.92132 6.65386 8.66451 6.61551 9.26949 7.03697L9.84777 6.46413L10.3425 6.96355L9.76948 7.53118C10.0449 7.92492 10.1268 8.32297 10.1516 8.61088L9.46056 8.68087C9.4309 8.31445 9.29108 8.00508 9.06195 7.77377C8.7599 7.46886 8.28437 7.3358 7.96369 7.65346C7.65089 7.96333 7.84939 8.46038 8.06114 8.99058C8.16611 9.25342 8.27433 9.52442 8.32513 9.78479C8.40692 10.1933 8.37846 10.6798 7.9579 11.0964C7.39539 11.6536 6.63141 11.6605 6.02644 11.239L5.45342 11.8067L4.95869 11.3072L5.53171 10.7396C5.18855 10.2775 5.03425 9.71169 5.09985 9.1155L5.81666 9.12412Z"></path>
    </svg>
  );
};
